import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Row, Col, Label, Card, CardBody, Input, CardTitle, CardHeader, FormGroup } from "reactstrap";
import { toast } from "react-toastify";
import DataTable from "../../components/common/DataTable";
import ConfirmModal from "../../components/common/ConfirmModal";
import PageHeader from "../../components/common/PageHeader";
import { getSaloonsRequest , getSaloonInfo } from "../../redux/saloons/actions";
import { api,
		FRONT_BASE_URL,
		isActionPermitted,
		socket, 
		SUPER_ADMIN_LOGIN_ID, 
		SOCKET , LOCAL_STORAGE_USER , ENABLE_STATUS_TEXT, STATUS, SELECTION, SEAT_SELECTION } from "../../util";
import { getAccountsRequest } from "../../redux/accounts/actions";
import { getLocationsRequest } from "../../redux/locations/actions";
import { getUsersRequest } from "../../redux/users/actions";
import Select from 'react-select'

const SalonManage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { users } = useSelector((state) => state.users);
  const { saloons, count, loading } = useSelector((state) => state.saloons);
  const { permissions , accountId} = useSelector((state) => state.user);
  const [saloonId , setSaloonId] = useState(null);
  
  const [showSeatStatusModal, setShowSeatStatusModal] = useState(false);
  const [showEmployeeSeatSelectionModal, setShowEmployeeSeatSelectionModal] = useState(false);
  const [showAcrossStoreEmployeeSeatSelectionModal, setShowAcrossStoreEmployeeSeatSelectionModal] = useState(false);
  const [currentSeatStatus , setCurrentSeatStatus] = useState(null);
  const [seatManagerId , setSeatManagerId] = useState(null);
  const [seatAcrossStoreManagerId , setSeatAcrossStoreManagerId] = useState(null);
  
  
  const [showAcrossShopSeatStatusModal, setShowAcrossShopSeatStatusModal] = useState(false);
  const [currentAcrossShopSeatStatus , setCurrentAcrossShopSeatStatus] = useState(null);
  
  const [paginationConfig, setPaginationConfig] = useState({
    page: 1,
    limit: 100,
    filter: {
      name: "",
      account: "",
      location: "",
    }
  });
  
  var userSelection = [];
  userSelection.push({ 'label' : 'Select' , 'value' : '' });
  users.map( (_, index) => (
		  userSelection.push({ "value": _.id, "label": _.firstName })
  ))
  
  var acrossStoreUserSelection = [];
  acrossStoreUserSelection.push({ 'label' : 'Select' , 'value' : '' });
  users.map((user, index) => {
	  if (user.store_access === "Multi" || user.id === SUPER_ADMIN_LOGIN_ID ) {
	    acrossStoreUserSelection.push({
	      value: user.id,
	      label: user.firstName
	    });
	  }
	});
  
  useEffect(() => {
	    dispatch(getUsersRequest({
	        filter: {
	          onlyAdmin:true,
	        },
	      }));
}, []);

  useEffect(() => {
    dispatch(getSaloonsRequest(paginationConfig));
  }, [paginationConfig, permissions]);

  const onSearchChange = ({ target }) => {
    const { value } = target;
    const pc = paginationConfig;
    pc.filter.name = value;
    setPaginationConfig({ ...pc,  page: 1, limit: 10 });
  };
  const getUserInfo = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER));
  const getTempUserInfo = JSON.parse(localStorage.getItem('temp_user_data'));
  
  console.log("getUserInfo" , getUserInfo );
  console.log("getTempUserInfo" , getTempUserInfo );
 
  const changeSaloonSeatStatus = async (saloonId, seatManagerId = null) => {
	    // var currentEnableDisableStatus = !e.target.checked;
	    const statusInfo = {
	      id: saloonId,
	      sit_status: currentSeatStatus,
	      managerId: seatManagerId
	    }
	    try {
	      const response = await api.post('/saloons/updateSeatStatus' , statusInfo);

	      if(response.status === 200) {
	        dispatch(getSaloonsRequest(paginationConfig));
	        toast.success(response?.data?.message || response.message);
	        socket.emit(SOCKET.EMIT_SALOON_SEAT_CHANGED,{});
	        socket.emit(SOCKET.EMIT_DISPLAY_NOTIFICATION,{});
	      }
	    } catch (error) {
	      toast.error(error.response?.data?.message || error.message);
	    }
  }
  const changeAcrossShopSaloonSeatStatus = async (saloonId, seatAcrossStoreManagerId = null) => {
	    // var currentEnableDisableStatus = !e.target.checked;
	    const statusInfo = {
	      id: saloonId,
	      across_store_sit_status: currentAcrossShopSeatStatus,
	      managerId: seatAcrossStoreManagerId
	    }
	    try {
	      const response = await api.post('/saloons/updateAcrossShopSeatStatus' , statusInfo);

	      if(response.status === 200) {
	        dispatch(getSaloonsRequest(paginationConfig));
	        toast.success(response?.data?.message || response.message);
	      }
	    } catch (error) {
	      toast.error(error.response?.data?.message || error.message);
	    }
  }
  const uploadSaloonSeatManager = async () => {
	  if (!seatManagerId) {
		  toast.error("Please Select Seat Manager");
	  }
	  changeSaloonSeatStatus(saloonId, seatManagerId)
  }
  const uploadSaloonAcrossSeatSeatManager = async () => {
	  if (!seatAcrossStoreManagerId) {
		  toast.error("Please Select Across Store Seat Manager");
	  }
	  changeAcrossShopSaloonSeatStatus(saloonId, seatAcrossStoreManagerId)
  }
  
  
  
  return (
    <React.Fragment>
    { isActionPermitted("saloon", "edit", permissions) && (
    	<PageHeader
        title="Manage Salons"
        addBtnUrl="/salons/add"
        shouldShowAddBtn={false}
      /> ) }
      <Card>
        <CardBody>
          <Row className="gy-3 gx-3">
            <Col xl={3} md={3} sm={12} xs={12}>
              <Label>Salon</Label>
              <Input
                value={paginationConfig.filter.name}
                type="search"
                placeholder="Search Salon"
                role="search"
                aria-roledescription="search for salon"
                autoFocus
                onChange={onSearchChange}
              />
            </Col>
          </Row>
        </CardBody>
      </Card> 
      <DataTable
        isPagination
        count={count}
        loading={loading}
        paginationConfig={paginationConfig}
        setPaginationConfig={setPaginationConfig}
        data={saloons}
        columns={[
          { Header: "Name", width: "20%", accessor: "Saloon.name" },
          {
              Header: "Store Manage Action",
              width: "40%",
              Cell: ({ row }) => {
            	 var isRestricted =
            	  ( row.original?.Saloon?.sit_status === SEAT_SELECTION.SEAT &&
            	  ![SUPER_ADMIN_LOGIN_ID, row.original?.Saloon?.workingPersonId].includes(getUserInfo.id) ) ? 'disabled' : '';
            	if(getTempUserInfo?.on_lunch !== 0){
            		//isRestricted = 'disabled';
            	}
            	return (
                  <div className="d-flex gap-2">
                      <div className="d-flex gap-2">
	  	                {isActionPermitted("saloon", "edit", permissions) && (
	  	                  <div className="form-check form-switch">
	  	                    <input type="checkbox" className="form-check-input" disabled={isRestricted}checked={row.original?.Saloon?.sit_status === SEAT_SELECTION.SEAT ? true : false}
	  	                      onChange={() => {
	  	                    	setSaloonId(row.original?.saloonId);
	  	                    	if (row.original?.Saloon?.sit_status === SEAT_SELECTION.SEAT) { 
	  	                    		setCurrentSeatStatus(row.original?.Saloon?.sit_status === SEAT_SELECTION.SEAT ? SEAT_SELECTION.SEAT : SEAT_SELECTION.UNSEAT);
		  	                        setShowSeatStatusModal(true);
	  	                    	} else {
	  	                    		setCurrentSeatStatus(row.original?.Saloon?.sit_status === SEAT_SELECTION.SEAT ? SEAT_SELECTION.SEAT : SEAT_SELECTION.UNSEAT);
	  	                    		if (getUserInfo.id ===  SUPER_ADMIN_LOGIN_ID) {
	  	                    			setShowEmployeeSeatSelectionModal(true);
	  	                    		} else {
	  	                    			setShowSeatStatusModal(true);
	  	                    		}
	  	                    		
	  	                    	}
	  	                    	
	  	                      }} />
	  	                    <div className="switch-wrapper">
	  	                    	<label className="form-check-label" htmlFor={"customSwitches-" + row.original?.saloonId}>
		  	                    	{row.original?.Saloon?.sit_status === SEAT_SELECTION.SEAT ? SEAT_SELECTION.SEAT : SEAT_SELECTION.UNSEAT }
		  	                    	<span className={
		  	                    	      ( row.original?.Saloon?.WorkingPerson?.firstName && row.original?.Saloon?.sit_status === SEAT_SELECTION.SEAT)
		  	                    	            ? "working-person assigned"
		  	                    	            : "working-person not-assigned"
		  	                    	        }>
			                    	{row.original?.Saloon?.sit_status === SEAT_SELECTION.SEAT
			                    		  ? `Working Person = ${
			                    		      row.original?.Saloon?.WorkingPerson?.firstName && row.original?.Saloon?.WorkingPerson?.lastName
			                    		        ? row.original.Saloon.WorkingPerson.firstName + ' ' + row.original.Saloon.WorkingPerson.lastName
			                    		        : ''
			                    		    }`
			                    		  : (row.original?.Saloon?.WorkingPerson?.firstName || row.original?.Saloon?.WorkingPerson?.lastName) && (
			                    				  `Last Working Person = ${
			                    				    row.original?.Saloon?.WorkingPerson?.firstName && row.original?.Saloon?.WorkingPerson?.lastName
			                    				      ? row.original.Saloon.WorkingPerson.firstName + ' ' + row.original.Saloon.WorkingPerson.lastName
			                    				      : 'null'
			                    				  }`
			                    				)
			                    		}
			                    	</span>
			                   </label>
			  	            </div>
	  	                  </div>
	  	                )}
	  	              </div>
		  	      </div>
                );
              },
            },
            {
                Header: "Across Store Action",
                width: "40%",
                class: ( getUserInfo?.store_access === "Multi" || getUserInfo.id ===  SUPER_ADMIN_LOGIN_ID) ? '' : 'd-none' ,
                Cell: ({ row }) => {
              	 const isRestricted =
              	  ( row.original?.Saloon?.across_store_sit_status === SEAT_SELECTION.SEAT &&
              	  ![SUPER_ADMIN_LOGIN_ID, row.original?.Saloon?.acrorssStoreWorkingPersonId].includes(getUserInfo.id) ) ? 'disabled' : '';
              	return (
                    <div className="d-flex gap-2">
                        <div className="d-flex gap-2">
  	  	                {isActionPermitted("saloon", "edit", permissions) && (
  	  	                  <div className="form-check form-switch">
  	  	                    <input type="checkbox" className="form-check-input" disabled={isRestricted}checked={row.original?.Saloon?.across_store_sit_status === SEAT_SELECTION.SEAT ? true : false}
  	  	                      onChange={() => {
  	  	                    	setCurrentAcrossShopSeatStatus(row.original?.Saloon?.across_store_sit_status === SEAT_SELECTION.SEAT ? SEAT_SELECTION.SEAT : SEAT_SELECTION.UNSEAT);
  	  	                    setSaloonId(row.original?.saloonId);
  	  	                    	  if (row.original?.Saloon?.across_store_sit_status === SEAT_SELECTION.SEAT) {
  	  	                    		setShowAcrossShopSeatStatusModal(true);
  	  	                    	  } else {
  	  	                    		if (getUserInfo.id ===  SUPER_ADMIN_LOGIN_ID) {
  	  	                    			setShowAcrossStoreEmployeeSeatSelectionModal(true);
  	  	                    		} else {
  	  	                    			setShowAcrossShopSeatStatusModal(true);
  	  	                    		}
  	  	                    	  }
  	  	                      }} />
  	  	                    <div className="switch-wrapper">
  	  	                    	<label className="form-check-label" htmlFor={"customSwitches-" + row.original?.saloonId}>
  		  	                    	{row.original?.Saloon?.across_store_sit_status === SEAT_SELECTION.SEAT ? SEAT_SELECTION.SEAT : SEAT_SELECTION.UNSEAT }
  		  	                    	<span className={
  		  	                    	      ( row.original?.Saloon?.acrorssStoreWorkingPerson?.firstName && row.original?.Saloon?.across_store_sit_status === SEAT_SELECTION.SEAT)
  		  	                    	            ? "working-person assigned"
  		  	                    	            : "working-person not-assigned"
  		  	                    	        }>
  			                    	{row.original?.Saloon?.across_store_sit_status === SEAT_SELECTION.SEAT
  			                    		  ? `Working Person = ${
  			                    		      row.original?.Saloon?.acrorssStoreWorkingPerson?.firstName && row.original?.Saloon?.acrorssStoreWorkingPerson?.lastName
  			                    		        ? row.original.Saloon.acrorssStoreWorkingPerson.firstName + ' ' + row.original.Saloon.acrorssStoreWorkingPerson.lastName
  			                    		        : ''
  			                    		    }`
  			                    		  : (row.original?.Saloon?.acrorssStoreWorkingPerson?.firstName || row.original?.Saloon?.acrorssStoreWorkingPerson?.lastName) && (
  			                    				  `Last Working Person = ${
  			                    				    row.original?.Saloon?.acrorssStoreWorkingPerson?.firstName && row.original?.Saloon?.acrorssStoreWorkingPerson?.lastName
  			                    				      ? row.original.Saloon.acrorssStoreWorkingPerson.firstName + ' ' + row.original.Saloon.acrorssStoreWorkingPerson.lastName
  			                    				      : 'null'
  			                    				  }`
  			                    				)
  			                    		}
  			                    	</span>
  			                   </label>
  			  	            </div>
  	  	                  </div>
  	  	                )}
  	  	              </div>
  		  	      </div>
                  );
                },
              }
        ]}
      />
      {showSeatStatusModal && (
        <ConfirmModal
          isOpen={showSeatStatusModal}
          setIsOpen={setShowSeatStatusModal}
          onOk={() => changeSaloonSeatStatus(saloonId)}
          onCancel={() => {
            setSaloonId(null);
            setCurrentSeatStatus(null);
            setShowSeatStatusModal(false);
          }}
          type="update"
          title="Update Seat Status"
        />
      )}
      
      {showEmployeeSeatSelectionModal && (
    		  <Modal isOpen={showEmployeeSeatSelectionModal}  size="lg" centered>
	    		  	<Card>
	    		  		<CardHeader>
	    		  			<CardTitle tag="h4">Select Seat Manager</CardTitle>
	    		  		</CardHeader>
	    		        <div className="d-flex justify-content-center">
	    		        	<div className="w-100">
	    		            	<CardBody>
	    		                 
	    		                 <Row>
	    		                  <Col xl={6}>
	    		                  <FormGroup>
	    		                    <Label for="manager_selection">Select Manager</Label>
	    		                    <Select options={userSelection}  
	    		                    onChange={(e) => {
	    		                    	setSeatManagerId(e.value);
	    		                    }}
	    		                    closeMenuOnSelect={true} />
	    		                    
	    		                  </FormGroup>
	    		                </Col>
	    		                </Row>
	    		                </CardBody>
	    		            </div>
	    		        </div>
	    		  </Card>
	    		  <ModalFooter>
	    		  	<Button color="primary" 
	    		  		onClick={(e) => {
	    		  			uploadSaloonSeatManager();
	    		  			setShowEmployeeSeatSelectionModal(false);
	    		  		}}
	    		  	>Submit</Button>
	    		  	<Button color="secondary"
	    		  		onClick={(e) => {
	    		  			setShowEmployeeSeatSelectionModal(false);
	    		  		}} 
	    		  	>Close</Button>
	    		  </ModalFooter>
    		  </Modal>        
      )}
      
      {showAcrossStoreEmployeeSeatSelectionModal && (
    		  <Modal isOpen={showAcrossStoreEmployeeSeatSelectionModal}  size="lg" centered>
	    		  	<Card>
	    		  		<CardHeader>
	    		  			<CardTitle tag="h4">Select Across Seat Seat Manager</CardTitle>
	    		  		</CardHeader>
	    		        <div className="d-flex justify-content-center">
	    		        	<div className="w-100">
	    		            	<CardBody>
	    		                 
	    		                 <Row>
	    		                  <Col xl={6}>
	    		                  <FormGroup>
	    		                    <Label for="across_seat_manager_selection">Select Manager</Label>
	    		                    <Select options={acrossStoreUserSelection}  
	    		                    onChange={(e) => {
	    		                    	setSeatAcrossStoreManagerId(e.value);
	    		                    }}
	    		                    closeMenuOnSelect={true} />
	    		                    
	    		                  </FormGroup>
	    		                </Col>
	    		                </Row>
	    		                </CardBody>
	    		            </div>
	    		        </div>
	    		  </Card>
	    		  <ModalFooter>
	    		  	<Button color="primary" 
	    		  		onClick={(e) => {
	    		  			uploadSaloonAcrossSeatSeatManager();
	    		  			setShowAcrossStoreEmployeeSeatSelectionModal(false);
	    		  		}}
	    		  	>Submit</Button>
	    		  	<Button color="secondary"
	    		  		onClick={(e) => {
	    		  			setShowAcrossStoreEmployeeSeatSelectionModal(false);
	    		  		}} 
	    		  	>Close</Button>
	    		  </ModalFooter>
    		  </Modal>        
      )}
      
      
      {showAcrossShopSeatStatusModal && (
    	        <ConfirmModal
    	          isOpen={showAcrossShopSeatStatusModal}
    	          setIsOpen={setShowAcrossShopSeatStatusModal}
    	          onOk={() => changeAcrossShopSaloonSeatStatus(saloonId)}
    	          onCancel={() => {
    	            setSaloonId(null);
    	            setCurrentAcrossShopSeatStatus(null);
    	            setShowAcrossShopSeatStatusModal(false);
    	          }}
    	          type="update"
    	          title="Update Seat Status"
    	        />
    	      )}
    </React.Fragment>
  );
};

export default SalonManage;
